import vars from './_vars';

// Helper functions:
import { throttle } from './functions/throttle';

/**
 * Tweak for mobiles (full height)
 */
const fixFullheight = () => {
	const vh = window.innerHeight * 0.01;
	vars.htmlEl.style.setProperty('--vh', `${vh}px`);
};

fixFullheight();
const fixHeight = throttle(fixFullheight);
window.addEventListener('resize', fixHeight);

/**
  * Force load of all lazy-loading images
  */
setTimeout(() => {
	var lazyloadImages = document.querySelectorAll('.lazyload.loading');
	lazyloadImages.forEach(image => {
		image.classList.remove('loading');
		image.classList.add('loaded');
	});
}, 3000);


/**
 * Nice select
 */
// Do not activate NiceSelect on those pages where it might conflict with Select2
if (!document.body.classList.contains('woocommerce-account')) {
	var selectElements = document.querySelectorAll('select');
	selectElements.forEach(function (select) {
		// new NiceSelect(select);
	});
}


/**
  * Trigger NiceSelect update after Woocommerce Update variations
  */
var variationsForm = document.querySelector('.variations_form');
if (variationsForm) {
	variationsForm.addEventListener('woocommerce_variation_has_changed', function () {
		var selectElements = variationsForm.querySelectorAll('select');
		selectElements.forEach(function (select) {
			// select.nextElementSibling.niceSelect('update');
		});
	});
}

// JS Lazyload fix for images on the first screen.
// This code should run after all the code is initiated.
window.dispatchEvent(new Event('scroll'));
